import { HotelTicketCardResponse } from './index.model';

// const centerLat = 36.85013321641722;
// const centerLng = 31.06983087646374;

export const mappingHotelTicketCard = (payload: any): any => {
    const mapData =
        payload.data.map((item: HotelTicketCardResponse) => {
            return {
                id: item.facility_reference,
                km: item.distance,
                rating: item.star_number,
                location: item.location,
                city: item.city,
                title: item.name,
                vote: item.survey_score,
                amenities: item.amenities,
                now_price: item.line_items.net_price_after_taxes.amount,
                price_currency: item.line_items.net_price_after_taxes.currency,
                discount: item.line_items.discounts.otelcampaign.percent,
                discount_price: item.line_items.gross_price.amount,
                thumbnail: item.image_url,
                rooms_size: item.last_room_number,
                opportunities: item.opportunities,
                pension_label: item.pension_label,
                pension_reference: item.pension_reference,
                room_label: item.room_detail.room_items[0].label || '',
                shopping_file_id: item.shopping_file_id,
                latitude: item.latitude,
                longitude: item.longitude,
                cancellable: item.line_items.cancellation.cancellable || false,
                price_index: item.price_index,
                sort_index: item.sort_index,
            };
        }) || [];

    return {
        ...payload,
        data: mapData,
    };
};

// export const mappingHotelTicketCard = (payload: any): any => {
//     const mapData = (payload || []).map(() => {
//         return {
//             id: Math.floor(Math.random() * 9999),
//             km: Math.min(Math.random() * 20 + 0.2, 20).toFixed(2),
//             rating: Math.min(Math.random() * 5 + 1, 5),
//             location: 'Alaçatı, Çeşme, İzmir',
//             title: 'Radisson Blu Resort & Spa Çeşme',
//             vote: Math.min(Math.random() * 10 + 5, 10),
//             now_price: Math.floor(Math.random() * (1500 - 100000 + 1) + 100000),
//             thumbnail: 'https://source.unsplash.com/random/250x250/?hotel+pool',
//             room_size: Math.floor(Math.min(Math.random() * 10 + 2, 10)),
//             discount: Math.floor(Math.min(Math.random() * 10 + 2, 10)) > 5,
//             url: `/radisson-blue-resort-spa-cesme-35/?checkInDate=20240125&checkOutDate=20240126&guest=2&child=3,4`,
//             latitude: centerLat + Math.random(),
//             longitude: centerLng + Math.random(),
//         };
//     });

//     return {
//         data: mapData,
//         success: true,
//     };
// };
